import { DDD, E2Data} from "../lib/ddd/ddd";
import FormWizard from "../components/formWizardOverride/FormWizard";
//import "react-form-wizard-component/dist/style.css";
import { Row, Col, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import classes from "./ClientWizard.module.scss";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import BusinessIcon from '@mui/icons-material/Business';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import StorageIcon from '@mui/icons-material/Storage';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import MyProfile from "./MyProfile";
import Profile from "../components/clientWizard/Profile";
import ServicesContainer from "../components/servicesComponents/ServicesContainer";
import IssuingMode from "../components/servicesComponents/IssuingMode";
import MoveToProduction from "../components/clientWizard/MoveToProduction";
import { OrgIdContext, ClientTypes } from "../store/orgId_context";
import { UserUIStateContext } from "../store/userUIStateContext";
import CustomerRelationsComponent from "../components/clientWizard/customerRelations/CustomerRelationsComponent";
import Packages from "../components/clientWizard/packages/Packages";
import ServicesTable2 from "../components/servicesComponents/servicesTable/ServicesTable2";
import HandshakeIcon from '@mui/icons-material/Handshake';
import SLA from "../components/clientWizard/SLA";
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data_EU_WorkflowSteps = new E2Data("EU_WorkflowSteps");
const e2Data_EU_SCR = new E2Data("EU_SCR");

const ClientWizard = () => {
    const {  isIntegrator, ISVCustomer, clientType } = useContext(OrgIdContext);
    const {clientWizardStep, serverDataLoaded, setClientWizardStepHandler, setClientWizardFinishedHandler} = useContext(UserUIStateContext);
    const formWizardRef = useRef(null);
    const SLARef = useRef(null);
    const [saveForm, setSaveForm] = useState();
    const { t } = useTranslation();

    const tabChanged = ({prevIndex,nextIndex,}) => {
        if(!serverDataLoaded)
            return;
        if(clientWizardStep === null){
            setClientWizardStepHandler(nextIndex);
        }else if(nextIndex > clientWizardStep){
            setClientWizardStepHandler(nextIndex);
        }
    };

    const handleComplete = () => {
        setClientWizardFinishedHandler(true);
    };

    useEffect(() => {
        if(clientWizardStep>0)
            formWizardRef.current.goToTab(clientWizardStep-1);
    }, [clientWizardStep])

    const validateSLA = () =>{
        if(!SLARef)
            return true;
        return SLARef.current.validate();
    }

    const saveFormRef = useCallback((formRef) =>{
        setSaveForm(formRef);
    }, []);

    const onSaveForm = () => {
        if(!saveForm?.manualSave) return;

        saveForm?.manualSave().then(res =>{
            console.error("fired")
            formWizardRef.current.nextTabForce();
        });
    }

    return (
        <>
        <Helmet>
            <title>Company init | DDD Invoices</title>
        </Helmet>
        <div className={`w-100 ${classes.container} ${classes["p-lrb-5"]}`}>
        <main>
            <FormWizard
                onComplete={handleComplete}
                onTabChange={tabChanged}
                ref={formWizardRef}
                finishButtonTemplate={function(){}}
                >
                <FormWizard.TabContent 
                    title={t("Your information")}
                    icon={<BusinessIcon/>}
                    _isValid = {onSaveForm}>
                    <div className={classes["profile-wrapper"]}>
                        <Profile saveRef={saveFormRef}  hideSave={true}/>
                    </div>
                </FormWizard.TabContent>
                <FormWizard.TabContent title={t("Distribution")} icon={<StorageIcon/>}>
                  {/*   <ServicesContainer/> */}
                  <ServicesTable2/>
                </FormWizard.TabContent>
                {false && clientType === ClientTypes.ISV &&
                    <FormWizard.TabContent title={t("Your clients")} icon={<SupervisorAccountIcon/>}>
                        <CustomerRelationsComponent></CustomerRelationsComponent>
                    </FormWizard.TabContent>
                }
                <FormWizard.TabContent title={t("Bussiness Packages")} icon={<StorageIcon/>}>
                    <Packages wrapIt="false"></Packages>
                </FormWizard.TabContent>
                <FormWizard.TabContent 
                    title="SLA" 
                    icon={<HandshakeIcon/>}
                    _isValid = {validateSLA}>
                    <SLA ref={SLARef}/>
                </FormWizard.TabContent>
                <FormWizard.TabContent title={t("Move to production")} icon={<ToggleOnIcon/>}>
                    <MoveToProduction/>
                </FormWizard.TabContent>
            </FormWizard>
        </main>
        </div>
        </>
    )
}

export default ClientWizard;